import { Interpolator } from '@ardatan/string-interpolation'

export const interpolateText = (text: string, data: any) => {
  const interpolator = new Interpolator({ delimiter: ['{{', '}}'] })
  return interpolator.parse(text, data)
}
